import React from 'react'

class FeedbackVorlage extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      fill="#C7E6FF"
                      fillRule="nonzero"
                      d="M.661 0H11.04l4.416 4.04v13.48c0 .366-.296.662-.662.662H.661c-.365 0-.661-.296-.661-.661V.66C0 .296.296 0 .661 0z"
                      transform="translate(-340.000000, -278.000000) translate(328.000000, 208.000000) translate(0.000000, 48.000000) translate(12.000000, 22.000000) translate(2.272727, 0.909091)"
                    />
                    <path
                      fill="#6696C7"
                      d="M11.039 0l4.415 4.04H11.7c-.365 0-.661-.296-.661-.66V0z"
                      opacity=".5"
                      transform="translate(-340.000000, -278.000000) translate(328.000000, 208.000000) translate(0.000000, 48.000000) translate(12.000000, 22.000000) translate(2.272727, 0.909091)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default FeedbackVorlage
